import { ColumnDef } from "@tanstack/react-table";
import { TIVisibleFeatures, VisibleFeature } from "../../types/types";

// Define structure for transmission line props
export interface TransmissionLineProps {
    ID: string;
    SUB_1: string;
    SUB_2: string;
    VOLTAGE: number;
    TYPE: string;
    STATUS: string;
    OWNER: string;
    // will add remaining when available
}

// Define specific transmission feature type
export interface TransmissionLineFeature extends VisibleFeature {
    properties: TransmissionLineProps;
}

// Type guard to check if a feature is a transmission line
export function isTransmissionLineFeature(
    feature: VisibleFeature
): feature is TransmissionLineFeature {
    return (
        feature.type === TIVisibleFeatures.transmission &&
        "properties" in feature
    );
}

// Transform a TransmissionLineFeature into a display format
export interface TransmissionLineDisplay {
    id: string;
    fromSubstation: string;
    toSubstation: string;
    voltage: number;
    type: string;
    status: string;
    owner: string;
}

// Helper function to transform feature data into display format
export function transformTransmissionLineFeature(
    feature: TransmissionLineFeature
): TransmissionLineDisplay {
    return {
        id: feature.properties.ID || "N/A",
        fromSubstation: feature.properties.SUB_1 || "N/A",
        toSubstation: feature.properties.SUB_2 || "N/A",
        voltage: feature.properties.VOLTAGE || 0,
        type: feature.properties.TYPE || "N/A",
        status: feature.properties.STATUS || "N/A",
        owner: feature.properties.OWNER || "N/A",
    };
}

export const transmissionLineColumns: ColumnDef<TransmissionLineDisplay>[] = [
    {
        accessorKey: "id",
        header: "ID",
        enableSorting: true,
    },
    {
        accessorKey: "fromSubstation",
        header: "From",
        enableSorting: true,
    },
    {
        accessorKey: "toSubstation",
        header: "To",
        enableSorting: true,
    },
    {
        accessorKey: "voltage",
        header: "Voltage",
        enableSorting: true,
    },
    {
        accessorKey: "type",
        header: "Type",
        enableSorting: true,
    },
    {
        accessorKey: "status",
        header: "Status",
        enableSorting: true,
    },
    {
        accessorKey: "owner",
        header: "Owner",
        enableSorting: true,
    },
];
